import axios from 'axios';

export const trackUserAgent = ( // eslint-disable-line
  userAgent,
  authToken,
  brand,
) =>
  axios.post(
    `${process.env.API}/track/useragent/${brand}`,
    { userAgent },
    { headers: { Authorization: `Bearer ${authToken}` } },
  );
